import type { OccasionType } from '@forbiz/contracts'

/**
 * 시스템 기본 상용구 (설계 6.1). 주문서 문구 칩과 빠른 주문 설정 '자주 쓰는 문구'에서 공유한다.
 * 근조·축하는 리본 윗줄(ribbonLine1), 난·기타는 카드(cardMessage)에 들어간다.
 * 회사 커스텀 문구(company_phrase)는 이 위에 합쳐 노출한다(BIZ-48).
 */
export const OCCASION_LABEL: Record<OccasionType, string> = {
  FUNERAL: '근조',
  CELEBRATION: '축하',
  GIFT: '난·기타',
}

export const SYSTEM_PHRASES: Record<OccasionType, string[]> = {
  FUNERAL: ['삼가 고인의 명복을 빕니다', '謹弔'],
  CELEBRATION: ['祝 結婚', '祝 開業'],
  GIFT: ['늘 건강하시고 하시는 일마다 번창하시길 바랍니다'],
}

/**
 * 리본 문구 입력 placeholder — 고른 화환 유형(축하는 행사 종류까지)에 맞는 예시.
 * 축하·난 주문에도 근조 문구가 떠 있던 어색함을 없앤다. 행사 종류는 자유 입력이라
 * 키워드 포함으로 느슨하게 맞춘다(못 맞추면 범용 축하 문구).
 */
export function ribbonPhrasePlaceholder(occ: OccasionType, eventType?: string): string {
  if (occ === 'FUNERAL') return '삼가 고인의 명복을 빕니다'
  if (occ === 'CELEBRATION') {
    const t = (eventType ?? '').trim()
    if (t.includes('결혼')) return '결혼을 진심으로 축하합니다'
    if (t.includes('개업') || t.includes('개원') || t.includes('오픈')) return '개업을 진심으로 축하드립니다'
    if (t.includes('승진') || t.includes('영전') || t.includes('취임')) return '승진을 진심으로 축하드립니다'
    if (t.includes('수상') || t.includes('당선')) return '수상을 진심으로 축하드립니다'
    return '앞날의 무궁한 발전을 기원합니다'
  }
  return '감사의 마음을 담아 보냅니다'
}

/** 보내는 사람 placeholder — 유형별 관례 예시(근조는 일동, 축하는 대표 명의, 난·기타는 드림). */
export function senderNamePlaceholder(occ: OccasionType): string {
  if (occ === 'FUNERAL') return '○○주식회사 임직원 일동'
  if (occ === 'CELEBRATION') return '(주)○○ 대표이사 ○○○'
  return '(주)○○ 드림'
}
